import webAiWidgetRouteGuard from '@/utils/routeGuards/webAIWidgetRouteGuard';

const routes = [
  {
    path: '/online-presence/web-ai-widget',
    name: 'online-presence-web-ai-widget',
    component: () => import(/* webpackChunkName: "WebAIWidgetPage" */ './views/WebAIWidgetPage.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Web AI Widget',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
  {
    path: '/online-presence/web-ai-widget/history/:conversation_uid',
    name: 'online-presence-web-ai-widget-history-conversation',
    component: () => import(/* webpackChunkName: "WebAIWidgetPage" */ './views/WebAIWidgetPage.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Web AI Widget Conversation',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
];

export default routes;
